// import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    order: null,
  },
  mutations: mutations,
  // actions: actions,
  getters: getters
}
